var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaximize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m473.67 407.48v-302.96c22.12-6.5 38.33-26.99 38.33-51.19 0-29.41-23.93-53.33-53.33-53.33-24.21 0-44.7 16.2-51.19 38.33-4.545 0-298.386 0-302.96 0-6.49-22.13-26.98-38.33-51.19-38.33-29.4 0-53.33 23.92-53.33 53.33 0 24.2 16.21 44.69 38.33 51.19v302.96c-22.12 6.5-38.33 26.99-38.33 51.19 0 29.41 23.93 53.33 53.33 53.33 24.21 0 44.7-16.2 51.19-38.33h302.96c6.49 22.13 26.98 38.33 51.19 38.33 29.4 0 53.33-23.92 53.33-53.33 0-24.2-16.21-44.69-38.33-51.19zm-66.19 36.19h-302.96c-5.09-17.37-18.82-31.1-36.19-36.19v-128.98h188.958l94.166 94.167h-38.527c-8.284 0-15 6.716-15 15s6.716 15 15 15h74.74c8.309 0 14.974-6.773 14.998-14.956 0-.015.002-.029.002-.044v-74.74c0-8.284-6.716-15-15-15s-15 6.716-15 15v38.527l-94.167-94.167v-188.957h128.98c5.09 17.37 18.82 31.1 36.19 36.19v302.96c-17.37 5.09-31.1 18.82-36.19 36.19zm-158.98-195.17h-180.17v-143.98c17.37-5.09 31.1-18.82 36.19-36.19h143.98z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximize);
export default __webpack_public_path__ + "static/media/maximize.4557b1ca.svg";
export { ForwardRef as ReactComponent };